export enum PortalFunction {
    UpdateBoardMembers = 1,
    CreatePinboardMessage = 2,
}

export enum PortalFunctionStatus {
    Enabled = 0,
    Disabled = 1,
}

// Placeholder for PAs without areas - the PA itself acts as the area
export const NO_AREA_PLACEHOLDER = '_';
